<template>
  <div id="lawStories">
    <article>
      <h1 class="main-title">סיפורים מעולם המשפט</h1>
    </article>

    <article>
      <allStories id="allStories" :currStory="currLawStory" />
    </article>

    <article>
      <copyRights id="copyRights" />
    </article>
  </div>
</template>

<script>
import allStories from "@/components/AllStories.vue";
import copyRights from "@/components/CopyRights.vue";
import { mapState } from "vuex";

export default {
  name: "lawStories",
  components: {
    allStories,
    copyRights
  },
  computed: {
    ...mapState(["currLawStory"])
  },
  metaInfo() {
    return {
      title: "איילת נוף טור אישי",
      meta: [
        {
          name: "description",
          content: "טור אישי המכיל סיפורים מרתקים מעולם המשפט"
        }
      ]
    };
  }
};
</script>

<style scoped>
#lawStories {
  direction: rtl;
}
#allStories {
  padding-top: 4vh;
  margin: 0 auto;
  width: 63%;
}
#copyRights {
  padding-top: 0.8rem;
}
</style>